import * as Styles from "./styles";
import {useGlobalStore} from "../core/GlobalStore";

export const ContainerAppLoader = (props: { loaderText: string }) => {
  const {isNavBarCollapsed} = useGlobalStore() ;
  const NAV_W = isNavBarCollapsed ? 14 : 74; 

  return (
    <Styles.LoaderContainer
      data-testid="loader-container"
      style={{ top: '48px', left: `${NAV_W}px`, pointerEvents: 'none' }}
    >
      <Styles.Loader />
      <h4>{props.loaderText}</h4>
    </Styles.LoaderContainer>
  );
};

export const AppLoader = (props: { loaderText: string }) => {
  return (
    <Styles.LoaderContainer data-testid="loader-container">
      <Styles.Loader />
      <h4>{props.loaderText}</h4>
    </Styles.LoaderContainer>
  );
};